import { render, staticRenderFns } from "./NavDrawer-v3.vue?vue&type=template&id=55491baf&scoped=true"
import script from "./NavDrawer-v3.vue?vue&type=script&lang=js"
export * from "./NavDrawer-v3.vue?vue&type=script&lang=js"
import style0 from "./NavDrawer-v3.vue?vue&type=style&index=0&id=55491baf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55491baf",
  null
  
)

export default component.exports